import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, intlShape } from 'react-intl';
import MediaCard from '@redbubble/design-system/react/MediaCard';
import Text from '@redbubble/design-system/react/Text';
import * as constants from '@redbubble/design-system/react/constants';

const messages = defineMessages({
  loading: 'Loading...'
});

const PlaceholderCard = ({ intl, transparent, showProductCount }) => {
  const loadingMessage = intl.formatMessage(messages.loading);

  return (
    <MediaCard
      loading
      title={loadingMessage}
      caption={loadingMessage}
      imageRatio={constants.RATIO_SQUARE}
      imageCover
      transparent={transparent}
    >
      {showProductCount && <Text loading>{loadingMessage}</Text>}
    </MediaCard>
  );
};

PlaceholderCard.propTypes = {
  transparent: PropTypes.bool,
  showProductCount: PropTypes.bool,
  intl: intlShape.isRequired
};

PlaceholderCard.defaultProps = {
  transparent: false,
  showProductCount: true
};

export default PlaceholderCard;
